import {Row, Col, Container, Form} from "react-bootstrap";
import refreshlogo from "../../assets/image/refresh.svg";
import React, {useContext, useEffect, useState} from "react";
import useWindowDimensions from "hooks/Dimensions";
import {ActionPanelContext} from "context/action";
import PropTypes from "prop-types";
import ActionsApproveRejectRenderer from "../ActionsApproveRejectRenderer";

export default function StatusOptionsModal(props) {
    const {isMobile} = useWindowDimensions();
    const {handleRefresh, defaultStatus} = useContext(ActionPanelContext);
    const [selectedStatus, setSelectedStatus] = useState(props.mnyWiresScreen?(props.refreshCriteria?.status || defaultStatus || 'ALL') : (props.refreshCriteria?.status || defaultStatus || 'PEND'))

    // When defaultStatus changes (e.g. parent page updates its default),
    // reset the dropdown's selected value to follow the new default.
    useEffect(() => {
        const nextStatus = props.mnyWiresScreen?  defaultStatus || 'ALL'  : defaultStatus || 'PEND';
        setSelectedStatus(nextStatus);
        if (props.refreshCriteria) {
            props.refreshCriteria.status = nextStatus;
        }
        if (props.gridApi && props.rowData) {
            setGridApi(nextStatus);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultStatus])

    const onRefreshClicked = () => {
        const onSuccess = () => {
        }
        const onError = () => {
        }

        props.refreshCriteria.status = selectedStatus;
        handleRefresh(props.refreshCriteria, onSuccess, onError);
    }

    const onStatusDropdownChange = (e) => {
        const nextStatus = e.currentTarget.value;
        setSelectedStatus(nextStatus)
        setGridApi(nextStatus)
    }

    const onRadioButtonChange = (e) => {
        setSelectedStatus(e.currentTarget.id)
        props.refreshCriteria.status = e.currentTarget.id;
    }

    const onCancelButtonClicked = () => {
        props.setShow(false);
        props.setShowRefreshOptions(false);
        props.setShowStatusOptions(false);
        props.setShowRightSideOptions(false);
    }

    const onApplyButtonClicked = () => {
        props.setShow(false);
        props.setShowRefreshOptions(false);
        props.setShowStatusOptions(false);
        props.setShowRightSideOptions(false);
        setGridApi(selectedStatus)
    }

    const setGridApi = (status) => {
        props.gridApi.setRowData(status === "ALL" ? props.rowData : props.rowData.filter(e => e.status.trim().includes(status)))
    }

    return (<>
        <Col style={{padding: 0, paddingRight: 20, textAlign: "center", alignSelf: "center"}}
             className="text-nowrap d-none d-sm-block">Status</Col>
        <Col style={{padding: 0, paddingRight: 5}} className={' d-none d-sm-block'}>
            {props.wireTemplateScreen &&

                <Form.Control as="select" className={'unset-custom-arrows'}
                              value={selectedStatus} onChange={onStatusDropdownChange}
                              style={{padding: 0, width: 'auto', height: 30}}
                >
                    <option value={"ALL"}>ALL</option>
                    <option value={"PEND"}>Pending</option>
                    <option value={"APPROVE"}>Approved</option>
                    <option value={"REJECT"}>Rejected</option>
                    <option value={"DELETE"}>Deleted</option>

                </Form.Control>
            }
            {!props.wireTemplateScreen &&

                <Form.Control as="select" className={'unset-custom-arrows'}
                              value={selectedStatus} onChange={onStatusDropdownChange}
                              style={{padding: 0, width: 'auto', height: 30}}
                >
                    <option value={"ALL"}>ALL</option>
                    <option value={"PEND"}>Pending</option>
                    <option value={"CAPPR"}>Approved</option>
                    <option value={"CMPLT"}>Completed</option>
                    <option value={"REJECT"}>Rejected</option>

                </Form.Control>
            }
        </Col>
        <Col style={{padding: 0, paddingLeft: 5, paddingRight: 10, textAlign: "center", alignSelf: "center"}}
             className={' d-none d-sm-block'}>
            <button style={{border: 'none', background: "none"}} onClick={onRefreshClicked}
            >
                <img
                    src={refreshlogo}
                    height="25"
                    className="d-inline-block"
                    alt="React Bootstrap logo"
                />
            </button>
        </Col>
        <Col md={4} xs={12} className={'p-0 m-0 d-md-none'}>
            <Container className="py-0">
                <Form onSubmit={(e) => e.preventDefault()}>
                    <Form.Check type="radio" id='ALL' label='ALL' checked={selectedStatus === 'ALL'} name='status'
                                className='m-0' onChange={onRadioButtonChange}/>
                    <Form.Check type="radio" id='PEND' label='Pending' checked={selectedStatus === 'PEND'}
                                name='status' className='mt-2' onChange={onRadioButtonChange}/>
                    <Form.Check type="radio" id='CAPPR' label='CApproved' checked={selectedStatus === 'CAPPR'}
                                name='status' className='mt-2' onChange={onRadioButtonChange}/>
                    <Form.Check type="radio" id='TDAPPR' label='Approved' checked={selectedStatus === 'TDAPPR'}
                                name='status' className='mt-2' onChange={onRadioButtonChange}/>
                    <Form.Check type="radio" id='REJECT' label='Rejected' checked={selectedStatus === 'REJECT'}
                                name='status' className='mt-2' onChange={onRadioButtonChange}/>
                    <Row className={"justify-content-center"}>
                        <Col md={4} xs={12} sm={12}>
                            <button href="#" className='btn btn-block td-btn-primary-light'
                                    onClick={onApplyButtonClicked}>Apply
                            </button>
                        </Col>
                        <Col md={4} xs={12} sm={12} className='md-pr-0 d-md-block'>
                            <button className='btn btn-block td-btn-secondary-clear' href="#" onClick={onCancelButtonClicked}>Cancel
                            </button>
                        </Col>
                    </Row>
                </Form>
            </Container>
        </Col>
    </>);
}

StatusOptionsModal.defaultProps = {
    wireTemplateScreen: false
}
